// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Barcode.scss
// module id = 1240
// module chunks = 0